webpackJsonp([35783957827783],{

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = NextArrow;
	exports.PrevArrow = PrevArrow;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NextArrow(props) {
		var className = props.className,
		    style = props.style,
		    onClick = props.onClick;
	
		return _react2.default.createElement("div", { className: "arrow next-arrow", onClick: onClick });
	}
	
	function PrevArrow(props) {
		var className = props.className,
		    style = props.style,
		    onClick = props.onClick;
	
		return _react2.default.createElement("div", { className: "arrow prev-arrow", onClick: onClick });
	}

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\npadding-bottom: 40px;\n", ";\n.inside{\n   display: flex;\n   justify-content: space-between;\n\t ", ";\n}\n\n"], ["\npadding-bottom: 40px;\n", ";\n.inside{\n   display: flex;\n   justify-content: space-between;\n\t ", ";\n}\n\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\t width: 100%;\n\t overflow-y: scroll;\n"], ["\n\t width: 100%;\n\t overflow-y: scroll;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n\t min-width: 1230px;\n\t "], ["\n\t min-width: 1230px;\n\t "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n   flex: 0 0 15%\n   a{\n\t   display:block;\n\t   height:0px;\n\t   padding-bottom:100%;\n\t   background-size:cover;\n\t   background-position:center;\n   }\n"], ["\n   flex: 0 0 15%\n   a{\n\t   display:block;\n\t   height:0px;\n\t   padding-bottom:100%;\n\t   background-size:cover;\n\t   background-position:center;\n   }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _functions = __webpack_require__(6);
	
	var _reactSlick = __webpack_require__(59);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InstagramFeed = function (_Component) {
		_inherits(InstagramFeed, _Component);
	
		function InstagramFeed() {
			_classCallCheck(this, InstagramFeed);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this));
	
			_this.state = {
				instagrams: []
			};
			return _this;
		}
	
		InstagramFeed.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			//update using efront.com.au/instagram
	
			fetch('https://api.instagram.com/v1/users/3609558623/media/recent?access_token=3609558623.4a72510.031d4b5c070f4c74b51b08304e241665').then(function (results) {
				return results.json();
			}).then(function (data) {
				var instagrams = data.data.map(function (inst, index) {
	
					if (index < 6) {
	
						var timestampInMilliSeconds = inst.created_time * 1000;
	
						var date = new Date(timestampInMilliSeconds);
	
						var day = (date.getDate() < 10 ? '0' : '') + date.getDate();
						var month = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
						var year = date.getFullYear();
	
						var formattedDate = year + " " + month + " " + day;
	
						return _react2.default.createElement(
							Card,
							null,
							_react2.default.createElement(
								"a",
								{ href: inst.link, target: "_blank", style: { backgroundImage: "url(" + inst.images.standard_resolution.url + ")" } },
								" "
							),
							_react2.default.createElement(
								"p",
								null,
								formattedDate
							),
							_react2.default.createElement(
								"p",
								null,
								_react2.default.createElement(
									"span",
									null,
									"yarrabend_"
								),
								" ",
								inst.caption.text.substring(0, 44) + "..."
							)
						);
					}
				});
	
				_this2.setState({ instagrams: instagrams });
			});
		};
	
		InstagramFeed.prototype.render = function render() {
			return _react2.default.createElement(
				SocialCardWrapper,
				null,
				_react2.default.createElement(
					"div",
					{ className: "inside" },
					this.state.instagrams
				)
			);
		};
	
		return InstagramFeed;
	}(_react.Component);
	
	exports.default = InstagramFeed;
	
	
	var SocialCardWrapper = _styledComponents2.default.div(_templateObject, _functions.below.desktop(_templateObject2), _functions.below.tablet(_templateObject3));
	
	var Card = _styledComponents2.default.div(_templateObject4);
	module.exports = exports["default"];

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\t.slick-track {\n\t\tbackground-color: #3f3e3e;\n\t}\n\n\t.slick-track,\n\t.slick-list {\n\t\ttransform: none !important;\n\t}\n\n\t.arrow {\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\theight: 50px;\n\t\twidth: 50px;\n\t\tz-index: 1;\n\t\ttop: 60%;\n\t\ttransform: translateY(-50%);\n\t\tmargin: 0 2vw;\n\t\tcursor: pointer;\n\t\tz-index: 4;\n\t\t', '\n\t}\n\n\t.next-arrow {\n\t\tright: 0;\n\t\tbackground-image: url(', ');\n\t}\n\t.prev-arrow {\n\t\ttransform: rotate(180deg);\n\t\ttransform-origin: 50% 24%;\n\t\tbackground-image: url(', ');\n\t}\n\n\t.slick-dots {\n\t\tbottom: 9%;\n\t\twidth: 100%;\n\t\tlist-style: none;\n\t\ttext-align: center;\n\t\tz-index: 4;\n\t\tpadding-left: 3.5rem;\n\t\tpadding-right: 3.5rem;\n\t\tmargin: auto;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttext-align: left;\n\t\tposition: absolute;\n\t\t', '\n\t\tli {\n\t\t\t', '\n\t\t\t&:first-of-type {\n\t\t\t\t', ';\n\t\t\t}\n\t\t\tbutton {\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder: 1px solid white;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\t', '\n\t\t\t\t&:before, &:after {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\t', '\n\t\t\t\t}\n\t\t\t\t:hover:before {\n\t\t\t\t\tbackground: white;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t:before {\n\t\t\t\t\tcontent: \'\';\n\t\t\t\t\tbackground-color: white;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\topacity: 0;\n\t\t\t\t\ttransition: opacity 0.5s;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.slick-active button:before {\n\t\t\t\tbackground: white;\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\n\t\t', '\n\t}\n'], ['\n\t.slick-track {\n\t\tbackground-color: #3f3e3e;\n\t}\n\n\t.slick-track,\n\t.slick-list {\n\t\ttransform: none !important;\n\t}\n\n\t.arrow {\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\theight: 50px;\n\t\twidth: 50px;\n\t\tz-index: 1;\n\t\ttop: 60%;\n\t\ttransform: translateY(-50%);\n\t\tmargin: 0 2vw;\n\t\tcursor: pointer;\n\t\tz-index: 4;\n\t\t', '\n\t}\n\n\t.next-arrow {\n\t\tright: 0;\n\t\tbackground-image: url(', ');\n\t}\n\t.prev-arrow {\n\t\ttransform: rotate(180deg);\n\t\ttransform-origin: 50% 24%;\n\t\tbackground-image: url(', ');\n\t}\n\n\t.slick-dots {\n\t\tbottom: 9%;\n\t\twidth: 100%;\n\t\tlist-style: none;\n\t\ttext-align: center;\n\t\tz-index: 4;\n\t\tpadding-left: 3.5rem;\n\t\tpadding-right: 3.5rem;\n\t\tmargin: auto;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttext-align: left;\n\t\tposition: absolute;\n\t\t', '\n\t\tli {\n\t\t\t', '\n\t\t\t&:first-of-type {\n\t\t\t\t', ';\n\t\t\t}\n\t\t\tbutton {\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder: 1px solid white;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\t', '\n\t\t\t\t&:before, &:after {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\t', '\n\t\t\t\t}\n\t\t\t\t:hover:before {\n\t\t\t\t\tbackground: white;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t:before {\n\t\t\t\t\tcontent: \'\';\n\t\t\t\t\tbackground-color: white;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\topacity: 0;\n\t\t\t\t\ttransition: opacity 0.5s;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.slick-active button:before {\n\t\t\t\tbackground: white;\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\n\t\t', '\n\t}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n         display: none;\n      '], ['\n         display: none;\n      ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n\t\t\t\ttext-align: right;\n\t\t\t\twidth: 40%;\n\t\t\t\tright: 0;\n\t\t\t\tleft: initial !important;\n\t\t\t\ttransform: none !important;\n\t\t\t'], ['\n\t\t\t\ttext-align: right;\n\t\t\t\twidth: 40%;\n\t\t\t\tright: 0;\n\t\t\t\tleft: initial !important;\n\t\t\t\ttransform: none !important;\n\t\t\t']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t'], ['\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n\t\t\t\t\tmargin-left: 13.25rem;\n\t\t\t\t\t'], ['\n\t\t\t\t\tmargin-left: 13.25rem;\n\t\t\t\t\t']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n\t\t\t\t width:12px;\n\t\t\t\t height:12px;\n\t\t\t\t '], ['\n\t\t\t\t width:12px;\n\t\t\t\t height:12px;\n\t\t\t\t ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n         margin: 0;\n         left: 50%;\n         bottom: 3%;\n         transform: translateX(-50%);\n      '], ['\n         margin: 0;\n         left: 50%;\n         bottom: 3%;\n         transform: translateX(-50%);\n      ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n\theight: 100vh;\n\t', '\n\n\timg {\n\t\twidth: 100%;\n\t\theight: 100vh;\n\t\tobject-fit: cover;\n\n\t\t', '\n\t}\n\t.img {\n\t\tposition: relative;\n\t\t&:before {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tbackground: linear-gradient(\n\t\t\t\tto bottom,\n\t\t\t\trgba(63, 62, 62, 0.4) 0%,\n\t\t\t\trgba(63, 62, 62, 0.2) 20%,\n\t\t\t\trgba(0, 0, 0, 0) 100%\n\t\t\t);\n\t\t}\n\t}\n'], ['\n\theight: 100vh;\n\t', '\n\n\timg {\n\t\twidth: 100%;\n\t\theight: 100vh;\n\t\tobject-fit: cover;\n\n\t\t', '\n\t}\n\t.img {\n\t\tposition: relative;\n\t\t&:before {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tbackground: linear-gradient(\n\t\t\t\tto bottom,\n\t\t\t\trgba(63, 62, 62, 0.4) 0%,\n\t\t\t\trgba(63, 62, 62, 0.2) 20%,\n\t\t\t\trgba(0, 0, 0, 0) 100%\n\t\t\t);\n\t\t}\n\t}\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n\theight: 90vh;\n   '], ['\n\theight: 90vh;\n   ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n\t      height: 90vh;\n\t   '], ['\n\t      height: 90vh;\n\t   ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n\t/* border: 1px solid magenta; */\n\twidth: 100%;\n\tposition: absolute;\n\tcolor: white;\n\ttop: 30%;\n\tz-index: 4;\n\tleft: 0;\n\tmargin-top: 110px;\n\tpointer-events: none;\n\n\t', '\n\t', '\n\n   p {\n\t\tbackground: rgba(0, 0, 0, 0.6);\n\t\tbox-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.6);\n\t\tpadding: 0;\n\t\tmargin-bottom: 15px;\n\t\tmax-width: 500px;\n\t\t', '\n\t}\n\n\th1 {\n\t\tfont-size: 7.7rem;\n\t\tline-height: 7.7rem;\n\t\tpadding-bottom: 15px;\n\t\t', '\n\t}\n\t', '\n\n\ta {\n\t\tpointer-events: auto;\n\t}\n'], ['\n\t/* border: 1px solid magenta; */\n\twidth: 100%;\n\tposition: absolute;\n\tcolor: white;\n\ttop: 30%;\n\tz-index: 4;\n\tleft: 0;\n\tmargin-top: 110px;\n\tpointer-events: none;\n\n\t', '\n\t', '\n\n   p {\n\t\tbackground: rgba(0, 0, 0, 0.6);\n\t\tbox-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.6);\n\t\tpadding: 0;\n\t\tmargin-bottom: 15px;\n\t\tmax-width: 500px;\n\t\t', '\n\t}\n\n\th1 {\n\t\tfont-size: 7.7rem;\n\t\tline-height: 7.7rem;\n\t\tpadding-bottom: 15px;\n\t\t', '\n\t}\n\t', '\n\n\ta {\n\t\tpointer-events: auto;\n\t}\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n\t   margin-top:-30px;\n\t'], ['\n\t   margin-top:-30px;\n\t']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n\t   margin-top: 0;\n\t\ttop: initial;\n\t\tbottom: 3%;\n   '], ['\n\t   margin-top: 0;\n\t\ttop: initial;\n\t\tbottom: 3%;\n   ']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n      background: rgba(0, 0, 0, 0.4);\n      box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.4);\n      '], ['\n      background: rgba(0, 0, 0, 0.4);\n      box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.4);\n      ']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n         font-size: 4.5rem;\n         line-height: 0.9;\n         letter-spacing: 0;\n      '], ['\n         font-size: 4.5rem;\n         line-height: 0.9;\n         letter-spacing: 0;\n      ']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n      margin-left: 2rem;\n      width: 90%;\n   '], ['\n      margin-left: 2rem;\n      width: 90%;\n   ']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n\tborder-top: 1px solid;\n\tborder-bottom: none;\n\tbackground-image: linear-gradient(', ' 60%, white 30%);\n\n\t.grid {\n\t\tmargin: 7rem auto;\n\t}\n'], ['\n\tborder-top: 1px solid;\n\tborder-bottom: none;\n\tbackground-image: linear-gradient(', ' 60%, white 30%);\n\n\t.grid {\n\t\tmargin: 7rem auto;\n\t}\n']),
	    _templateObject18 = _taggedTemplateLiteralLoose(['\n   position: relative;\n   display: block;\n   z-index: 10;\n   padding-top: 10rem;\n   padding-bottom: 10rem;\n\n   ', '\n'], ['\n   position: relative;\n   display: block;\n   z-index: 10;\n   padding-top: 10rem;\n   padding-bottom: 10rem;\n\n   ', '\n']),
	    _templateObject19 = _taggedTemplateLiteralLoose(['\n      padding: 3rem 0;\n      background-color: ', '\n   '], ['\n      padding: 3rem 0;\n      background-color: ', '\n   ']),
	    _templateObject20 = _taggedTemplateLiteralLoose(['\n\tposition: relative;\n\toverflow: hidden;\n\tcolor: ', ';\n\tpadding: 24.1rem 5rem 3rem 5rem;\n\tbackground-size: cover;\n\tbackground-position: center bottom;\n\tflex-basis: 97%;\n\n\t&:first-child:last-child {\n\t\tflex-basis: 100%;\n\t}\n\n\th3 {\n\t\tmax-width: 28rem;\n\t\tpadding-bottom: 1rem;\n\t}\n\n\th3,\n\tp {\n\t\tposition: relative;\n\t}\n\n\t&.h100 {\n\t\tposition: relative;\n\t\tpadding-top: 55rem;\n\n\t\t', ';\n\n\t\t.text {\n\t\t\t', ';\n\t\t}\n\t}\n\n\t', '\n\n\t&:before {\n\t\tcontent: \'\';\n\t\twidth: 101%;\n\t\theight: 101%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tbackground-image: linear-gradient(\n\t\t\t0,\n\t\t\trgba(0, 0, 0, 0.8) 0%,\n\t\t\trgba(0, 0, 0, 0.3) 40%,\n\t\t\trgba(241, 111, 92, 0) 100%\n\t\t);\n\t}\n'], ['\n\tposition: relative;\n\toverflow: hidden;\n\tcolor: ', ';\n\tpadding: 24.1rem 5rem 3rem 5rem;\n\tbackground-size: cover;\n\tbackground-position: center bottom;\n\tflex-basis: 97%;\n\n\t&:first-child:last-child {\n\t\tflex-basis: 100%;\n\t}\n\n\th3 {\n\t\tmax-width: 28rem;\n\t\tpadding-bottom: 1rem;\n\t}\n\n\th3,\n\tp {\n\t\tposition: relative;\n\t}\n\n\t&.h100 {\n\t\tposition: relative;\n\t\tpadding-top: 55rem;\n\n\t\t', ';\n\n\t\t.text {\n\t\t\t', ';\n\t\t}\n\t}\n\n\t', '\n\n\t&:before {\n\t\tcontent: \'\';\n\t\twidth: 101%;\n\t\theight: 101%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tbackground-image: linear-gradient(\n\t\t\t0,\n\t\t\trgba(0, 0, 0, 0.8) 0%,\n\t\t\trgba(0, 0, 0, 0.3) 40%,\n\t\t\trgba(241, 111, 92, 0) 100%\n\t\t);\n\t}\n']),
	    _templateObject21 = _taggedTemplateLiteralLoose(['\n         padding-top: 24.1rem;\n      '], ['\n         padding-top: 24.1rem;\n      ']),
	    _templateObject22 = _taggedTemplateLiteralLoose(['\n         position: absolute;\n         bottom:5rem;\n         '], ['\n         position: absolute;\n         bottom:5rem;\n         ']),
	    _templateObject23 = _taggedTemplateLiteralLoose(['\n      padding: 24.1rem 2rem 2rem 2rem;\n   '], ['\n      padding: 24.1rem 2rem 2rem 2rem;\n   ']),
	    _templateObject24 = _taggedTemplateLiteralLoose(['\n\tposition: relative;\n\toverflow: hidden;\n\tcolor: ', ';\n\tpadding: 24.1rem 0 3rem 5rem;\n\tbackground-size: cover;\n\tbackground-position: center bottom;\n\tflex-basis: 97%;\n\n\t', '\n\n\th3 {\n\t\tmax-width: 28rem;\n\t\tpadding-bottom: 1rem;\n\t}\n\n\th3,\n\tp {\n\t\tposition: relative;\n\t\tz-index: 4;\n\t}\n\n\t&.h100 {\n\t\tposition: relative;\n\t\tpadding-top: 55rem;\n\n\t\t', ';\n\n\t\t.text {\n\t\t\t', ';\n\t\t}\n\t}\n\n\t', '\n\n\t&:before {\n\t\tcontent: \'\';\n\t\twidth: 101%;\n\t\theight: 101%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tbackground-image: linear-gradient(\n\t\t\t0,\n\t\t\trgba(0, 0, 0, 0.8) 0%,\n\t\t\trgba(0, 0, 0, 0.3) 40%,\n\t\t\trgba(241, 111, 92, 0) 100%\n\t\t);\n\t}\n\n\t.video-wrapper {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\n\t.btn {\n\t\tz-index: 4;\n\t}\n'], ['\n\tposition: relative;\n\toverflow: hidden;\n\tcolor: ', ';\n\tpadding: 24.1rem 0 3rem 5rem;\n\tbackground-size: cover;\n\tbackground-position: center bottom;\n\tflex-basis: 97%;\n\n\t', '\n\n\th3 {\n\t\tmax-width: 28rem;\n\t\tpadding-bottom: 1rem;\n\t}\n\n\th3,\n\tp {\n\t\tposition: relative;\n\t\tz-index: 4;\n\t}\n\n\t&.h100 {\n\t\tposition: relative;\n\t\tpadding-top: 55rem;\n\n\t\t', ';\n\n\t\t.text {\n\t\t\t', ';\n\t\t}\n\t}\n\n\t', '\n\n\t&:before {\n\t\tcontent: \'\';\n\t\twidth: 101%;\n\t\theight: 101%;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tbackground-image: linear-gradient(\n\t\t\t0,\n\t\t\trgba(0, 0, 0, 0.8) 0%,\n\t\t\trgba(0, 0, 0, 0.3) 40%,\n\t\t\trgba(241, 111, 92, 0) 100%\n\t\t);\n\t}\n\n\t.video-wrapper {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\n\t.btn {\n\t\tz-index: 4;\n\t}\n']),
	    _templateObject25 = _taggedTemplateLiteralLoose(['\n\t   padding: 24.1rem 5rem 3rem 5rem;\n   '], ['\n\t   padding: 24.1rem 5rem 3rem 5rem;\n   ']),
	    _templateObject26 = _taggedTemplateLiteralLoose(['\n      padding: 24.1rem 0 2rem 2rem;\n   '], ['\n      padding: 24.1rem 0 2rem 2rem;\n   ']),
	    _templateObject27 = _taggedTemplateLiteralLoose(['\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t&.dir-column {\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\t\tflex-direction: column;\n\t\tflex-grow: 1;\n\t}\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t&.dir-column {\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\t\tflex-direction: column;\n\t\tflex-grow: 1;\n\t}\n\n\t', ';\n']),
	    _templateObject28 = _taggedTemplateLiteralLoose(['\n      flex-direction: column;\n   '], ['\n      flex-direction: column;\n   ']),
	    _templateObject29 = _taggedTemplateLiteralLoose(['\n\tpadding-top: 40px;\n\ta {\n\t\ttext-decoration: none;\n\t}\n'], ['\n\tpadding-top: 40px;\n\ta {\n\t\ttext-decoration: none;\n\t}\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSlick = __webpack_require__(59);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _functions = __webpack_require__(6);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _video = __webpack_require__(46);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _header = __webpack_require__(21);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _content_block = __webpack_require__(112);
	
	var _content_block2 = _interopRequireDefault(_content_block);
	
	var _instagramFeed = __webpack_require__(403);
	
	var _instagramFeed2 = _interopRequireDefault(_instagramFeed);
	
	var _prismicReactjs = __webpack_require__(18);
	
	var _arrowRightWhite = __webpack_require__(286);
	
	var _arrowRightWhite2 = _interopRequireDefault(_arrowRightWhite);
	
	var _stickyEnquire = __webpack_require__(45);
	
	var _stickyEnquire2 = _interopRequireDefault(_stickyEnquire);
	
	var _arrows = __webpack_require__(143);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import 'slick-carousel/slick/slick.css'
	// import 'slick-carousel/slick/slick-theme.css'
	
	var settings = {
		dots: true,
		dotsClass: 'slick-dots grid',
		//   autoplay: true,
		fade: true,
		infinite: true,
		autoplaySpeed: 4750,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		waitForAnimate: false,
		nextArrow: _react2.default.createElement(_arrows.NextArrow, null),
		prevArrow: _react2.default.createElement(_arrows.PrevArrow, null)
	};
	
	var homePage = function (_React$Component) {
		_inherits(homePage, _React$Component);
	
		function homePage(props) {
			_classCallCheck(this, homePage);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.componentWillMount = function () {};
	
			_this.state = {
				autoplay: true
			};
			_this.pause = _this.pause.bind(_this);
			return _this;
		}
	
		homePage.prototype.pause = function pause() {
			this.setState({ autoplay: false });
		};
	
		homePage.prototype.componentDidMount = function componentDidMount() {
			var meta = this.props.data.prismicHomepagev2.data;
			this.props.updateMeta(meta.meta_title.text, meta.meta_description);
			this.props.togglePopup(false);
			this.props.updatePageType(this.props.data.prismicHomepagev2.type);
			this.props.updateFooterVisible(true);
			if (document) {
				if (document.querySelector('.prev-arrow') !== null) {
					document.querySelector('.prev-arrow').addEventListener('click', this.pause);
				}
	
				if (document.querySelector('.next-arrow') !== null) {
					document.querySelector('.next-arrow').addEventListener('click', this.pause);
				}
	
				if (document.querySelector('.slick-dots') !== null) {
					document.querySelector('.slick-dots').addEventListener('click', this.pause);
				}
	
				if (document.querySelector('.video-wrapper>div') !== null) {
					document.querySelector('.video-wrapper>div').addEventListener('click', this.pause());
				}
			}
		};
	
		homePage.prototype.render = function render() {
			var _this2 = this;
	
			var data = this.props.data.prismicHomepagev2.dataString;
			data = JSON.parse(data);
	
			var data2 = this.props.data.prismicMainNavigation.dataString;
			data2 = JSON.parse(data2);
	
			var _props$data$prismicHo = this.props.data.prismicHomepagev2.data.body,
			    slides = _props$data$prismicHo[0].items,
			    textGrey = _props$data$prismicHo[1].primary,
			    youTube = _props$data$prismicHo[2].primary,
			    textWhite = _props$data$prismicHo[3].primary,
			    tileGrid = _props$data$prismicHo[4].items;
	
	
			var allSlides = [];
			slides.map(function (slide, i) {
				var link = slide.link.text;
				var link_text = slide.link_text.text;
				var slide_bg_image = slide.slide_bg_image.url;
				var slide_bg_mobile_image = typeof slide.slide_bg_mobile_image !== 'undefined' ? slide.slide_bg_mobile_image.url : false;
				var slide_description = slide.slide_description.html;
				var slide_title = slide.slide_title.text;
	
				var link_is_external = /^(http[s]?|\/\/)/.test(slide.link.text);
	
				allSlides.push({
					id: i,
					slide_title: slide_title,
					slide_description: slide_description,
					slide_bg_image: slide_bg_image,
					slide_bg_mobile_image: slide_bg_mobile_image,
					link_text: link_text,
					link: link,
					link_is_external: link_is_external
				});
	
				return allSlides;
			});
	
			var allGrid = [];
			tileGrid.map(function (gridItem, i) {
				var link = gridItem.link.text;
				var link_text = gridItem.link_text.text;
				var bg = gridItem.tile_background.url;
				var description = gridItem.description.html;
				var title = gridItem.title.html;
				var youtube_link = gridItem.youtube__optional_ ? gridItem.youtube__optional_.url : false;
	
				allGrid.push({ id: i, title: title, description: description, bg: bg, link_text: link_text, link: link, youtube_link: youtube_link });
	
				return allGrid;
			});
	
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_header2.default, {
					togglePopup: this.props.togglePopup,
					theme: 'trans',
					menu: this.props.data.prismicMainNavigation.data
				}),
				_react2.default.createElement(_stickyEnquire2.default, {
					theme: 'light',
					togglePopupState: this.props.popupVisible,
					togglePopup: this.props.togglePopup,
					utm: this.props.utm,
					updateFormDetails: function updateFormDetails(first_name, last_name, phone, email) {
						return _this2.props.updateFormDetails(first_name, last_name, phone, email);
					}
				}),
				_react2.default.createElement(
					SlideshowWrapper,
					null,
					_react2.default.createElement(
						_reactSlick2.default,
						_extends({ autoplay: this.state.autoplay }, settings),
						allSlides.map(function (slide, i) {
							return _react2.default.createElement(
								SlideImgWrapper,
								{ key: i },
								_react2.default.createElement(
									'div',
									{ className: 'img' },
									_react2.default.createElement(
										'picture',
										null,
										slide.slide_bg_mobile_image && _react2.default.createElement('source', {
											media: '(max-width: 600px)',
											srcSet: slide.slide_bg_mobile_image
										}),
										_react2.default.createElement('img', { src: slide.slide_bg_image })
									)
								),
								_react2.default.createElement(
									Blurb,
									{ className: 'blurb' },
									_react2.default.createElement(
										'div',
										{ className: 'grid' },
										_react2.default.createElement(
											'div',
											{ className: 'inner' },
											_react2.default.createElement(
												'h1',
												null,
												slide.slide_title.split('\n').map(function (item, key) {
													return _react2.default.createElement(
														'span',
														{ key: key },
														item,
														_react2.default.createElement('br', null)
													);
												})
											),
											_react2.default.createElement('div', {
												dangerouslySetInnerHTML: {
													__html: slide.slide_description
												}
											}),
											!slide.link_is_external ? _react2.default.createElement(
												_gatsbyLink2.default,
												{ to: slide.link, className: 'btn btn-square white' },
												_react2.default.createElement(
													'span',
													null,
													slide.link_text
												)
											) : _react2.default.createElement(
												'a',
												{ href: slide.link, className: 'btn btn-square white', target: '_blank' },
												_react2.default.createElement(
													'span',
													null,
													slide.link_text
												)
											)
										)
									)
								)
							);
						})
					)
				),
				_react2.default.createElement(
					VideoContent,
					null,
					_react2.default.createElement(_content_block2.default, {
						header: [{ type: 'heading1', text: textGrey.title.text, spans: [] }],
						subheader: [{ type: 'heading2', text: '', spans: [] }],
						text: [{ type: 'paragraph', text: textGrey.text.text, spans: [] }],
						cta: textGrey.link.text,
						ctaText: textGrey.link_text.text,
						invertColor: true,
						home: true
					}),
					_react2.default.createElement(
						'div',
						{ className: 'grid' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'div',
								{ className: 'col col-xs-12 col-12 ' },
								_react2.default.createElement(_video2.default, { poster: youTube.poster.url, url: youTube.link.text, inline: true })
							)
						)
					),
					_react2.default.createElement(_content_block2.default, {
						header: [{ type: 'heading1', text: textWhite.title.text, spans: [] }],
						subheader: [{ type: 'heading2', text: '', spans: [] }],
						text: [{ type: 'paragraph', text: textWhite.text.text, spans: [] }],
						cta: textWhite.link.text,
						ctaText: textWhite.link_text.text,
						invertColor: false
					})
				),
				_react2.default.createElement(
					FeatureWrapper,
					null,
					_react2.default.createElement(
						'div',
						{ className: 'grid' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							allGrid[0].youtube_link ? _react2.default.createElement(
								FeatureVideos,
								{ className: 'h100' },
								_react2.default.createElement(
									'div',
									{ className: 'text' },
									_react2.default.createElement('div', {
										dangerouslySetInnerHTML: {
											__html: allGrid[0].title
										}
									}),
									_react2.default.createElement('div', {
										dangerouslySetInnerHTML: {
											__html: allGrid[0].description
										}
									}),
									_react2.default.createElement(
										'span',
										{
											style: { cursor: 'pointer', 'pointer-events': 'none' },
											className: 'btn btn-square transparent'
										},
										_react2.default.createElement(
											'span',
											null,
											allGrid[0].link_text
										)
									)
								),
								_react2.default.createElement(_video2.default, {
									url: allGrid[0].youtube_link,
									poster: allGrid[0].bg,
									popup: true
								})
							) : _react2.default.createElement(
								FeatureItems,
								{
									className: 'h100',
									style: { backgroundImage: 'url(' + allGrid[0].bg + ')' }
								},
								_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: allGrid[0].title } }),
								_react2.default.createElement('div', {
									dangerouslySetInnerHTML: { __html: allGrid[0].description }
								}),
								_react2.default.createElement(
									_gatsbyLink2.default,
									{
										to: allGrid[0].link,
										className: 'btn btn-square transparent'
									},
									_react2.default.createElement(
										'span',
										null,
										allGrid[0].link_text
									)
								)
							),
							_react2.default.createElement(
								Flex,
								null,
								allGrid[1].youtube_link ? _react2.default.createElement(
									FeatureVideos,
									{ className: 'h100' },
									_react2.default.createElement(
										'div',
										{ className: 'text' },
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[1].title
											}
										}),
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[1].description
											}
										}),
										_react2.default.createElement(
											'span',
											{
												style: { cursor: 'pointer', 'pointer-events': 'none' },
												className: 'btn btn-square transparent'
											},
											_react2.default.createElement(
												'span',
												null,
												allGrid[1].link_text
											)
										)
									),
									_react2.default.createElement(_video2.default, {
										url: allGrid[1].youtube_link,
										poster: allGrid[1].bg,
										popup: true
									})
								) : _react2.default.createElement(
									FeatureItems,
									{
										className: 'h100 ',
										style: { backgroundImage: 'url(' + allGrid[1].bg + ')' }
									},
									_react2.default.createElement(
										'div',
										{ className: 'text' },
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[1].title
											}
										}),
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[1].description
											}
										}),
										_react2.default.createElement(
											_gatsbyLink2.default,
											{
												to: allGrid[1].link,
												className: 'btn btn-square transparent'
											},
											_react2.default.createElement(
												'span',
												null,
												allGrid[1].link_text
											)
										)
									)
								),
								_react2.default.createElement(
									Flex,
									{ className: 'dir-column' },
									allGrid[2].youtube_link ? _react2.default.createElement(
										FeatureVideos,
										{ className: 'h100' },
										_react2.default.createElement(
											'div',
											{ className: 'text' },
											_react2.default.createElement('div', {
												dangerouslySetInnerHTML: {
													__html: allGrid[2].title
												}
											}),
											_react2.default.createElement('div', {
												dangerouslySetInnerHTML: {
													__html: allGrid[2].description
												}
											}),
											_react2.default.createElement(
												'span',
												{
													style: { cursor: 'pointer', 'pointer-events': 'none' },
													className: 'btn btn-square transparent'
												},
												_react2.default.createElement(
													'span',
													null,
													allGrid[2].link_text
												)
											)
										),
										_react2.default.createElement(_video2.default, {
											url: allGrid[2].youtube_link,
											poster: allGrid[2].bg,
											popup: true
										})
									) : _react2.default.createElement(
										FeatureItems,
										{
											className: '',
											style: { backgroundImage: 'url(' + allGrid[2].bg + ')' }
										},
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[2].title
											}
										}),
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[2].description
											}
										}),
										_react2.default.createElement(
											_gatsbyLink2.default,
											{
												to: allGrid[2].link,
												className: 'btn btn-square transparent'
											},
											_react2.default.createElement(
												'span',
												null,
												allGrid[2].link_text
											)
										)
									),
									allGrid[3].youtube_link ? _react2.default.createElement(
										FeatureVideos,
										{ className: 'h100' },
										_react2.default.createElement(
											'div',
											{ className: 'text' },
											_react2.default.createElement('div', {
												dangerouslySetInnerHTML: {
													__html: allGrid[3].title
												}
											}),
											_react2.default.createElement('div', {
												dangerouslySetInnerHTML: {
													__html: allGrid[3].description
												}
											}),
											_react2.default.createElement(
												'span',
												{
													style: { cursor: 'pointer', 'pointer-events': 'none' },
													className: 'btn btn-square transparent'
												},
												_react2.default.createElement(
													'span',
													null,
													allGrid[3].link_text
												)
											)
										),
										_react2.default.createElement(_video2.default, {
											url: allGrid[3].youtube_link,
											poster: allGrid[3].bg,
											popup: true
										})
									) : _react2.default.createElement(
										FeatureItems,
										{
											className: '',
											style: { backgroundImage: 'url(' + allGrid[3].bg + ')' }
										},
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[3].title
											}
										}),
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[3].description
											}
										}),
										_react2.default.createElement(
											_gatsbyLink2.default,
											{
												to: allGrid[3].link,
												className: 'btn btn-square transparent'
											},
											_react2.default.createElement(
												'span',
												null,
												allGrid[3].link_text
											)
										)
									)
								)
							),
							_react2.default.createElement(
								Flex,
								null,
								allGrid[4].youtube_link ? _react2.default.createElement(
									FeatureVideos,
									{ className: 'h100' },
									_react2.default.createElement(
										'div',
										{ className: 'text' },
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[4].title
											}
										}),
										_react2.default.createElement('div', {
											dangerouslySetInnerHTML: {
												__html: allGrid[4].description
											}
										}),
										_react2.default.createElement(
											'span',
											{
												style: { cursor: 'pointer', 'pointer-events': 'none' },
												className: 'btn btn-square transparent'
											},
											_react2.default.createElement(
												'span',
												null,
												allGrid[4].link_text
											)
										)
									),
									_react2.default.createElement(_video2.default, {
										url: allGrid[4].youtube_link,
										poster: allGrid[4].bg,
										popup: true
									})
								) : _react2.default.createElement(
									FeatureItems,
									{
										className: '',
										style: { backgroundImage: 'url(' + allGrid[4].bg + ')' }
									},
									_react2.default.createElement('div', {
										dangerouslySetInnerHTML: { __html: allGrid[4].title }
									}),
									_react2.default.createElement('div', {
										dangerouslySetInnerHTML: {
											__html: allGrid[4].description
										}
									}),
									_react2.default.createElement(
										_gatsbyLink2.default,
										{
											to: allGrid[4].link,
											className: 'btn btn-square transparent'
										},
										_react2.default.createElement(
											'span',
											null,
											allGrid[4].link_text
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		return homePage;
	}(_react2.default.Component);
	
	var SlideshowWrapper = _styledComponents2.default.div(_templateObject, _functions.below.mid(_templateObject2), _arrowRightWhite2.default, _arrowRightWhite2.default, _functions.below.mobile(_templateObject3), _functions.below.mobile(_templateObject4), _functions.above.giant(_templateObject5), _functions.below.mobile(_templateObject6), _functions.below.mobile(_templateObject6), _functions.below.tablet(_templateObject7));
	var SlideImgWrapper = _styledComponents2.default.div(_templateObject8, _functions.below.mobile(_templateObject9), _functions.below.mobile(_templateObject10));
	var Blurb = _styledComponents2.default.div(_templateObject11, _functions.maxHeight.tablet(_templateObject12), _functions.below.mobile(_templateObject13), _functions.below.mobile(_templateObject14), _functions.below.mobile(_templateObject15), _functions.below.tablet(_templateObject16));
	
	var VideoContent = _styledComponents2.default.div(_templateObject17, vars.colors.body);
	
	var FeatureWrapper = _styledComponents2.default.div(_templateObject18, _functions.below.tablet(_templateObject19, vars.colors.body));
	
	var FeatureItems = _styledComponents2.default.div(_templateObject20, vars.colors.blank, _functions.below.tablet(_templateObject21), _functions.above.desktop(_templateObject22), _functions.below.tablet(_templateObject23));
	
	var FeatureVideos = _styledComponents2.default.div(_templateObject24, vars.colors.blank, _functions.below.desktop(_templateObject25), _functions.below.tablet(_templateObject21), _functions.above.desktop(_templateObject22), _functions.below.tablet(_templateObject26));
	
	var Flex = _styledComponents2.default.div(_templateObject27, _functions.below.tablet(_templateObject28));
	
	var SocialTitle = _styledComponents2.default.h2(_templateObject29);
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = homePage;

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNTAgNTAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO30uY2xzLTJ7ZmlsbDojMzEzMTMwO308L3N0eWxlPjxzeW1ib2wgaWQ9IldoaXRlX0Fycm93IiBkYXRhLW5hbWU9IldoaXRlIEFycm93IiB2aWV3Qm94PSIwIDAgMjMgMjMiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTkuNDU4MzcsMTcuMTEzNzcsOC40Mzc2MiwxNi4wOTNsNC41OTMyNi00LjU5MzE0TDguNDM3NjIsNi45MDY3NEg4LjQzOEw5LjQ1ODM3LDUuODg2LDE1LjA3MiwxMS40OTk4OCw5LjQ1ODM3LDE3LjExMzc3TTExLjQ5OTg4LDBBMTEuNSwxMS41LDAsMSwwLDIyLjk5OTc2LDExLjQ5OTg4LDExLjQ5OTg2LDExLjQ5OTg2LDAsMCwwLDExLjQ5OTg4LDAiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjkuNDU4IDUuODg2IDguNDM4IDYuOTA3IDguNDM4IDYuOTA3IDEzLjAzMSAxMS41IDguNDM4IDE2LjA5MyA5LjQ1OCAxNy4xMTQgMTUuMDcyIDExLjUgOS40NTggNS44ODYiLz48L3N5bWJvbD48L2RlZnM+PHRpdGxlPkdMRTEyNDg3X1dlYnNpdGVfSWNvbnM8L3RpdGxlPjx1c2Ugd2lkdGg9IjIyLjk5OTc2IiBoZWlnaHQ9IjIzLjAwMDA2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy45OTg3NSAxMy4wMDAyMikiIHhsaW5rOmhyZWY9IiNXaGl0ZV9BcnJvdyIvPjwvc3ZnPg=="

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-88db1f33866af6d130f9.js